import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Divider,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import AdminList from "./AdminList";
import appcolors from "../../../constants/Colors";
import { allIcons } from "../../../assets";
import CompanyList from "./CompanyList";
import CustomerList from "./CustomerList";
import { t } from "i18next";

const style = {
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: "#F3F3F3",
      "& .MuiOutlinedInput-notchedOutline": {
        border: `none`,
        boxShadow: "none",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `none`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `none`,
      },
    },
  },
};

function ListBox({ socket }) {
  return (
    <Paper sx={{ borderRadius: "10px" }}>
      {/* header */}
      <Stack gap={1.5} p={2} direction={"row"} alignItems={"center"}>
        <img
          src={allIcons.handshakeInactiveIcon}
          alt="handshake-icon"
          width={30}
        />
        <Stack direction={"row"} alignItems={"center"}>
          <Typography variant="h1" fontSize={"1.125rem"} fontWeight={"bold"}>
            {t('messages')}
          </Typography>
          <ExpandMoreIcon />
        </Stack>
      </Stack>
      <Divider />
      <Stack p={1} gap={1.5} height={"70vh"} overflow={"auto"}>
        <AdminList socket={socket} />
        <CompanyList socket={socket} />
        {/* <Typography fontSize={"1.125rem"} fontWeight={"bold"}>
          Users
        </Typography>
        <CustomerList socket={socket} /> */}
      </Stack>
    </Paper>
  );
}

export default ListBox;
